const SEO = [
	{
		page: "home",
		title: "Pavan Khiani | Product Builder for Experts & Creators",
		description:
			"Pavan Khiani is a product manager who helps industry experts and creators turn their knowledge and audience into monetizable products. Anyone can vibe code an app; knowing what to build and how to make money from it is the hard part.",
		keywords: [
			"Pavan",
			"Pavan K",
			"Pavan Khiani",
			"product manager",
			"products for creators",
			"products for experts",
			"monetization",
		],
	}
];

export default SEO;
